if (!customElements.get('info-tooltip')) {
  class InfoTooltip extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('info-tooltip', InfoTooltip);
}
